/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Outlook_Mail_Show_LessInputs */



/**
* | output |
* | --- |
* | "Show less" |
*
* @param {Chat_Outlook_Mail_Show_LessInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_outlook_mail_show_less = /** @type {((inputs?: Chat_Outlook_Mail_Show_LessInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Outlook_Mail_Show_LessInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Weniger anzeigen")
	return /** @type {LocalizedString} */ ("Show less")
});